import React from 'react';
import { CheckIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { DigitalMicrocopy } from '../DigitalMicrocopy';
import { offerIncludes } from '../../data/salesContent';
import { CHECKOUT_URL, PRICE, PRODUCT_IMAGE, PRODUCT_IMAGE_ALT } from '../../data/product';
export function OfferSection() {
  return <section id="offer" className="bg-night py-8 sm:py-12" aria-labelledby="offer-title" data-id="element-113" data-mp="aijs068p9w4e">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-114" data-mp="6irdlcwmkvr4">
        <div className="text-center" data-id="element-115" data-mp="1pybkwsjk1iq">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-lime" data-id="element-116" data-mp="1owzqq3pbazy">Get the complete system</p>
          <h2 id="offer-title" className="mt-4 font-display text-[32px] font-extrabold leading-[1.05] tracking-tight text-cream sm:text-5xl" data-id="element-117" data-mp="3sx2fvjxax9ng">
            Your Halloween PE Week Can Be <span className="text-pumpkin" data-id="element-118" data-mp="3ixtsxb0usval">Ready Today.</span>
          </h2>
        </div>

        <div className="mt-6 overflow-hidden rounded-[28px] bg-navy ring-2 ring-pumpkin" data-id="element-119" data-mp="3extc5jqa880d">
          <div className="grid lg:grid-cols-[1fr_1.05fr]" data-id="element-120" data-mp="1aqfsuea8o22m">
            <div className="flex items-center justify-center bg-panel p-4 sm:p-8" data-id="element-121" data-mp="1fj8x711sp8e6">
              <img src={PRODUCT_IMAGE} alt={PRODUCT_IMAGE_ALT} className="w-full max-w-[240px] sm:max-w-md" loading="lazy" data-id="element-122" data-mp="10tuj5fn9y2sg" />
            </div>

            <div className="p-5 sm:p-8" data-id="element-123" data-mp="1ti8lg7lebl9t">
              <h3 className="font-display text-xl font-extrabold tracking-tight text-cream sm:text-2xl" data-id="element-124" data-mp="1tjba08v8xbmk">
                HALLOWEEN PE READY™
              </h3>
              <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2" data-id="element-125" data-mp="1kilgxcxddzcj">
                {offerIncludes.map(item => <li key={item} className="flex items-start gap-1.5 text-[13px] leading-snug text-cream/90 sm:text-sm" data-id="element-126" data-mp="1oi41g7la48eu">
                    <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-lime" strokeWidth={3} aria-hidden="true" data-id="element-127" data-mp="91degx6aatb0" />
                    {item}
                  </li>)}
              </ul>

              <div className="mt-5 flex flex-wrap items-end gap-x-5 gap-y-2 border-t border-line pt-5" data-id="element-128" data-mp="2ft06jmfqascf">
                <p className="font-display text-5xl font-extrabold leading-none text-cream sm:text-6xl" data-id="element-129" data-mp="2atxa2qdtdug2">
                  {PRICE}
                  <span className="ml-2 text-lg font-bold text-muted" data-id="element-130" data-mp="212klc7nbbke9">USD</span>
                </p>
                <div className="pb-1 text-sm text-muted" data-id="element-131" data-mp="1x0yzvxwppxsg">
                  <p className="font-semibold text-cream" data-id="element-132" data-mp="1wyct40hnbmba">One-time payment.</p>
                  <p className="flex items-center gap-1.5" data-id="element-133" data-mp="1rzrshzyhf0mb">
                    <DownloadIcon className="h-3.5 w-3.5 text-lime" aria-hidden="true" data-id="element-134" data-mp="1n1q8nct8ex9s" />
                    Instant digital access after purchase.
                  </p>
                </div>
              </div>

              <div className="mt-5 flex flex-col gap-3" data-id="element-135" data-mp="3hgj5tg9rjw3u">
                <CtaButton href={CHECKOUT_URL} className="sm:w-full" data-id="element-136" data-mp="3hdwynhqsbim5">
                  Get Halloween PE Ready™ — {PRICE}
                </CtaButton>
                <DigitalMicrocopy items={['100% Digital', 'Downloadable PDFs', 'Instant Access']} align="center" data-id="element-137" data-mp="3kx5j2wekfnpw" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}